document.addEventListener('DOMContentLoaded', function () {
  initReveal();
  initFaq();
  initGaleriaProducto();
  initOpcionCards();
  initVariantes();
  initContador();
  initMarquesina();
  initBundleAdd();
  initStickyComprar();
});

function initReveal() {
  var els = document.querySelectorAll('.mt-reveal');
  if (!els.length) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
    els.forEach(function (el) { el.classList.add('mt-visible'); });
    return;
  }
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        entry.target.classList.add('mt-visible');
        observer.unobserve(entry.target);
      }
    });
  }, { threshold: 0.15 });
  els.forEach(function (el) { observer.observe(el); });
}

function initFaq() {
  var items = document.querySelectorAll('.mt-faq-item');
  if (!items.length) return;
  items.forEach(function (item) {
    var pregunta = item.querySelector('.mt-faq-pregunta');
    if (!pregunta) return;
    pregunta.addEventListener('click', function () {
      var abierto = item.classList.contains('mt-faq-item--abierto');
      items.forEach(function (i) { i.classList.remove('mt-faq-item--abierto'); });
      if (!abierto) item.classList.add('mt-faq-item--abierto');
    });
  });
}

function initGaleriaProducto() {
  var galeria = document.querySelector('.mt-galeria');
  if (!galeria) return;
  var contenedor = galeria.querySelector('.mt-galeria-principal');
  var miniaturas = galeria.querySelectorAll('.mt-galeria-mini');
  if (!contenedor || !miniaturas.length) return;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  miniaturas.forEach(function (mini) {
    mini.addEventListener('click', function () {
      var src = mini.getAttribute('data-full');
      var alt = (mini.getAttribute('data-alt') || '').replace(/"/g, '&quot;');
      var tipo = mini.getAttribute('data-tipo') || 'imagen';
      var videoSrc = mini.getAttribute('data-video-src');
      if (!src) return;
      function render() {
        if (tipo === 'video' && videoSrc) {
          contenedor.innerHTML = '<video controls playsinline preload="metadata" poster="' + src + '" style="width:100%;height:100%;object-fit:cover;border-radius:inherit;"><source src="' + videoSrc + '" type="video/mp4"></video>';
        } else {
          contenedor.innerHTML = '<img src="' + src + '" alt="' + alt + '" loading="eager">';
        }
        contenedor.classList.remove('mt-galeria-cambiando');
      }
      if (reduceMotion) {
        render();
      } else {
        contenedor.classList.add('mt-galeria-cambiando');
        setTimeout(render, 160);
      }
      miniaturas.forEach(function (m) { m.classList.remove('mt-galeria-mini--activa'); });
      mini.classList.add('mt-galeria-mini--activa');
    });
  });
}

function initOpcionCards() {
  var grupos = document.querySelectorAll('.mt-opcion');
  if (!grupos.length) return;
  grupos.forEach(function (grupo) {
    var select = grupo.querySelector('.mt-opcion-select');
    var cards = grupo.querySelectorAll('.mt-opcion-card');
    if (!select || !cards.length) return;
    cards.forEach(function (card) {
      card.addEventListener('click', function () {
        select.value = card.getAttribute('data-valor');
        cards.forEach(function (c) {
          c.classList.remove('mt-opcion-card--activa');
          c.setAttribute('aria-pressed', 'false');
        });
        card.classList.add('mt-opcion-card--activa');
        card.setAttribute('aria-pressed', 'true');
        select.dispatchEvent(new Event('change', { bubbles: true }));
      });
    });
  });
}

function initVariantes() {
  var form = document.querySelector('.mt-producto-form');
  if (!form) return;
  var dataEl = document.getElementById('mt-variantes-json');
  var idInput = form.querySelector('input[name="id"]');
  var precioEl = document.querySelector('.mt-precio-actual');
  var precioTachadoEl = document.querySelector('.mt-precio-tachado');
  var botonEl = form.querySelector('.mt-btn-comprar');
  var selects = form.querySelectorAll('.mt-opcion-select');
  if (!dataEl || !selects.length) return;

  var variantes;
  try { variantes = JSON.parse(dataEl.textContent); } catch (e) { return; }
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function moneyFmt(cents) {
    return '$' + Math.round(cents / 100).toLocaleString('es-CL');
  }

  function actualizar() {
    var seleccion = Array.from(selects).map(function (s) { return s.value; });
    var variante = variantes.find(function (v) {
      return v.options.every(function (opt, i) { return opt === seleccion[i]; });
    });
    if (!variante) return;
    idInput.value = variante.id;
    if (precioEl) {
      var nuevoPrecio = moneyFmt(variante.price);
      if (precioEl.textContent !== nuevoPrecio) {
        precioEl.textContent = nuevoPrecio;
        if (!reduceMotion) {
          precioEl.classList.remove('mt-pulso');
          void precioEl.offsetWidth;
          precioEl.classList.add('mt-pulso');
        }
      }
    }
    if (precioTachadoEl) {
      if (variante.compare_at_price && variante.compare_at_price > variante.price) {
        precioTachadoEl.textContent = moneyFmt(variante.compare_at_price);
        precioTachadoEl.style.display = '';
      } else {
        precioTachadoEl.style.display = 'none';
      }
    }
    if (botonEl) {
      if (variante.available) {
        botonEl.disabled = false;
        botonEl.textContent = botonEl.getAttribute('data-texto-disponible') || 'Añadir al carrito';
      } else {
        botonEl.disabled = true;
        botonEl.textContent = botonEl.getAttribute('data-texto-agotado') || 'Agotado';
      }
    }
  }

  selects.forEach(function (s) { s.addEventListener('change', actualizar); });
  actualizar();
}

function initContador() {
  var els = document.querySelectorAll('.mt-contador');
  if (!els.length) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      var el = entry.target;
      observer.unobserve(el);
      var fin = parseFloat(el.getAttribute('data-fin') || '0');
      var duracion = 1400;
      var inicio = null;
      function paso(ts) {
        if (!inicio) inicio = ts;
        var progreso = Math.min((ts - inicio) / duracion, 1);
        var valor = fin * (1 - Math.pow(1 - progreso, 3));
        el.textContent = (fin % 1 === 0 ? Math.round(valor) : valor.toFixed(1)).toString();
        if (progreso < 1) requestAnimationFrame(paso);
        else el.textContent = fin.toString();
      }
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        el.textContent = fin.toString();
      } else {
        requestAnimationFrame(paso);
      }
    });
  }, { threshold: 0.5 });
  els.forEach(function (el) { observer.observe(el); });
}

function initBundleAdd() {
  var botones = document.querySelectorAll('[data-bundle-add]');
  if (!botones.length) return;
  botones.forEach(function (btn) {
    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;
    var textoOriginal = btn.textContent;
    btn.addEventListener('click', function () {
      if (btn.disabled) return;
      btn.disabled = true;
      btn.textContent = 'Agregando…';
      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ id: variantId, quantity: 1 })
      })
        .then(function (res) { if (!res.ok) throw new Error('add-failed'); return res.json(); })
        .then(function () {
          btn.textContent = '✓ Agregada';
          return fetch('/?sections=cart-icon-bubble');
        })
        .then(function (res) { return res.json(); })
        .then(function (data) {
          var burbuja = document.getElementById('cart-icon-bubble');
          if (burbuja && data && data['cart-icon-bubble']) {
            var temp = document.createElement('div');
            temp.innerHTML = data['cart-icon-bubble'];
            var seccion = temp.querySelector('.shopify-section') || temp.firstElementChild;
            if (seccion) burbuja.innerHTML = seccion.innerHTML;
          }
        })
        .catch(function () {
          btn.textContent = 'Reintentar';
          btn.disabled = false;
        })
        .finally(function () {
          setTimeout(function () {
            btn.textContent = textoOriginal;
            btn.disabled = false;
          }, 2500);
        });
    });
  });
}

function initStickyComprar() {
  var barra = document.getElementById('mt-sticky-comprar');
  var boton = document.getElementById('mt-sticky-comprar-btn');
  var formBoton = document.querySelector('.mt-btn-comprar');
  if (!barra || !boton || !formBoton) return;
  var observer = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      barra.classList.toggle('mt-sticky-comprar--visible', !entry.isIntersecting);
    });
  }, { threshold: 0 });
  observer.observe(formBoton);
  boton.addEventListener('click', function () {
    formBoton.scrollIntoView({ behavior: 'smooth', block: 'center' });
  });
}

function initMarquesina() {
  var track = document.querySelector('.mt-marquesina-track');
  if (!track) return;
  track.innerHTML = track.innerHTML + track.innerHTML;
}
